import * as React from 'react';
import { FormGroup } from 'reactstrap';
import ValidationMessages from './ValidationMessages';
import { FieldRenderProps } from 'react-final-form';
import { FieldPropsWithDefaultValue } from '.';
import { default as ToggleInput } from 'react-toggle';
import 'react-toggle/style.css';
import FieldLabel from './FieldLabel';
import classnames from 'classnames';
import { toKebabCase } from 'util/StringUtil';
import Confirm from 'components/shared/Confirm';

export interface ToggleState {
	/**
	 * Determines if confirmation modal should be show or hide
	 */
	isConfirmationOpen: boolean;
}

/**
 * Component that renders a toggle for booleans
 *
 * @class Toggle
 * @extends {(React.Component<FieldRenderProps & FieldProps>)}
 */
class Toggle extends React.Component<
	FieldRenderProps<any, HTMLInputElement> & FieldPropsWithDefaultValue,
	ToggleState
> {
	public static defaultProps: Partial<FieldRenderProps<any, HTMLInputElement> & FieldPropsWithDefaultValue> = {
		indicateDirty: true,
	};

	constructor(props) {
		super(props);
		this.state = {
			isConfirmationOpen: false,
		};
	}

	public render() {
		const {
			input: { name, onChange, value },
			meta,
			disabled,
			readOnly,
			testId,
			defaultValue = false,
			indicateDirty,
			confirmationMessage,
			confirmationColor,
		} = this.props;
		const { isConfirmationOpen } = this.state;
		const checked: boolean = value === '' ? defaultValue : value;

		return (
			<FormGroup
				className={classnames('form-group--toggle', { 'form-group--dirty': indicateDirty && meta.dirty })}
			>
				<FieldLabel {...this.props}>
					<ToggleInput
						name={name}
						checked={checked}
						onChange={(e) => {
							if (confirmationMessage && e.currentTarget.checked) {
								this.setState({ isConfirmationOpen: true });
								return;
							}
							onChange(e.currentTarget.checked);
						}}
						icons={false}
						disabled={disabled || readOnly}
						data-testid={testId || `field-${toKebabCase(name)}`}
					/>
				</FieldLabel>
				<ValidationMessages meta={meta} id={name} />
				<Confirm
					onCancel={() => {
						this.setState({ isConfirmationOpen: false });
					}}
					isOpen={isConfirmationOpen}
					color={confirmationColor || 'default'}
					onConfirm={() => {
						onChange(true);
						this.setState({ isConfirmationOpen: false });
					}}
					renderTitle={() => ''}
					renderContents={() => <div dangerouslySetInnerHTML={{ __html: confirmationMessage }}></div>}
					confirmButtonText="Continue"
					cancelButtonText="Cancel"
				/>
			</FormGroup>
		);
	}
}

export default Toggle;
